import React, { useState } from 'react';
import { FileText, Eye, Save } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SaveSharedNoteModal from '../Notes/SaveSharedNoteModal';
import SharedNoteView from '../Notes/SharedNoteView';

const SharedNoteMessage = ({ message, isOwnMessage, groupId }) => {
  const { t } = useTranslation('chat');
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showNoteView, setShowNoteView] = useState(false);

  const noteTitle = message?.note_title || message?.noteTitle;
  const displayTitle = noteTitle && noteTitle.trim() ? noteTitle.trim() : t('common:unnamed');

  const cardBg  = isOwnMessage ? 'bg-[#1d3557] border-[#3d8ef0]/25' : 'bg-[var(--color-bg-muted)] border-white/[0.09]';
  const titleBg = isOwnMessage ? 'bg-white/[0.07]' : 'bg-[var(--color-bg-elevated)]';
  const btnPrimary   = 'bg-[#2563eb] hover:bg-[#3d8ef0] text-white';
  const btnSecondary = isOwnMessage
    ? 'bg-white/10 hover:bg-white/[0.18] text-[var(--color-text-primary)]'
    : 'bg-[#161f31] hover:bg-[#24354f] text-[var(--color-text-secondary)] border border-white/[0.07]';

  return (
    <>
      <div className={`rounded-2xl border ${cardBg} overflow-hidden min-w-[220px] max-w-[280px]`}>
        {/* Header */}
        <div className="flex items-center gap-2 px-4 py-2.5 border-b border-white/[0.06]">
          <FileText className="w-4 h-4 flex-shrink-0 text-[#3d8ef0]" />
          <span className="text-[11px] font-semibold text-[var(--color-text-muted)] uppercase tracking-wide">{t('sharedNoteCard.header')}</span>
        </div>
        {/* Body */}
        <div className="px-4 py-3">
          <div className={`${titleBg} rounded-xl px-3 py-2.5 mb-3`}>
            <p className="text-sm font-medium text-[var(--color-text-primary)] break-words line-clamp-2">"{displayTitle}"</p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => setShowNoteView(true)}
              className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold transition-colors ${btnSecondary}`}
            >
              <Eye className="w-3.5 h-3.5" />
              {t('sharedNoteCard.view')}
            </button>
            <button
              onClick={() => setShowSaveModal(true)}
              className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold transition-colors ${btnPrimary}`}
            >
              <Save className="w-3.5 h-3.5" />
              {t('common:save')}
            </button>
          </div>
        </div>
      </div>

      <SharedNoteView
        isOpen={showNoteView}
        onClose={() => setShowNoteView(false)}
        message={message}
        groupId={groupId}
        onSave={() => setShowSaveModal(true)}
      />
      <SaveSharedNoteModal
        isOpen={showSaveModal}
        onClose={() => setShowSaveModal(false)}
        message={message}
        groupId={groupId}
      />
    </>
  );
};

export default SharedNoteMessage;
